/* Configuración global de GSAP.
   Estaba inline en theme.liquid justo después de animations.min.js. Al pasar ese
   script a defer, un inline se ejecutaría ANTES que él (gsap sin definir), así que
   vive en su propio fichero con defer: los scripts defer se ejecutan en orden de
   documento, o sea justo después de animations.min.js y antes de slideshow/app. */
gsap.defaults({
  ease: Power4.easeOut
});
gsap.config({
  nullTargetWarn: false
});
gsap.registerPlugin(ScrollTrigger);
